import { IconArrowBack } from "@tabler/icons-react";
import forbidden_img from "assets/img/403-page.svg";
import { Link } from "react-router-dom";

export default function ForbiddenPage() {
  return (
    <div className="container-tight py-4 d-flex flex-column justify-content-center grow">
      <div className="empty">
        <div className="empty-img">
          <img src={forbidden_img} alt="" />
        </div>
        <div className="empty-header">403</div>
        <p className="empty-title">У вас нет доступа к данной странице</p>
        <p className="empty-subtitle text-secondary">
          Обратитесь к администратору для получения соответствующих прав доступа
        </p>
        <div className="empty-action">
          <Link to="/" replace className="btn btn-primary">
            <IconArrowBack className="icon" />
            На главную
          </Link>
        </div>
      </div>
    </div>
  );
}
